import React, { useEffect, useState } from "react";
import Select from "react-select";
import { apiService } from "../../service/ApiService";
import { Form } from "react-bootstrap";

import { useTranslation } from "react-i18next";

const DishOrderSelect = ({ title, defaultValue = null, handler, id = null }) => {
  const {
    t,
  } = useTranslation();

  title = title === undefined ? t("forms.placeholders.selectCourse") : title;
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  const handleChange = (e) => {
    setSelectedOption(e);
    if (e) handler(e.value);
    else handler(null);
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  const getData = async () => {
    try {
      const response = await apiService.get(`api/v1/dish-orders`);
      const availableOptions = response.map((el) => {
        return {
          value: el.id,
          label: el.description,
        };
      });
      setOptions(availableOptions);
      if (id) {
        availableOptions.map((o) => {
          if (o.value == id) {
            o.isDisabled = true;
            return o;
          }
        });
      }
      if (defaultValue) {
        const selected = availableOptions.find((el) => el.value === defaultValue);
        setSelectedOption(selected);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const setNewValue = () => {
    const selectedOption = options.find((el) => el.value === defaultValue);
    if (selectedOption) setSelectedOption(selectedOption);
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    setNewValue();
  }, [defaultValue]);

  return (
    <>
      <Form.Group>
        <label>{title}</label>
        <Select
          styles={customStyles}
          isClearable={true}
          className="primary"
          name="dishOrderSelect"
          onChange={handleChange}
          value={selectedOption}
          options={options}
          noOptionsMessage={() => t("messages.noCoursesAreAvailable")}
          placeholder={`${t("common.actions.select")} ${title}`}
        />
      </Form.Group>
    </>
  );
};

export default DishOrderSelect;
